<template>
    <div>
        <div class="bg-opacity-100 z-10 bg-gray-50 absolute inset-0"></div>
        <div class="absolute inset-0 flex justify-center items-center z-30">
            <svg class="animate-spin mr-3 h-10 w-10 text-red-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"> <circle class="opacity-25 text-red-300" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
            <span class="text-xs text-red-900 mt-2.5"><!-- loading -->{{$t('loading')}}...</span>
        </div>   
    </div>
</template>